import type { FC, HTMLAttributes, PropsWithChildren } from "react";
import * as s from "./ProductPage.module.scss";

const ProductPage: FC<PropsWithChildren & HTMLAttributes<HTMLDivElement>> = ({
	children,
	...props
}) => {
	return (
		<div className={s.container} {...props}>
			{children}
		</div>
	);
};

export default ProductPage;
